export const yearAnalyticsScope = (search) => {
    const params = new URLSearchParams(search)
    return {
        yearGroup: params.get('year') || '',
        // An explicit empty selection stays empty after reload.
        classIds: params.get('selection') === 'custom' || params.has('classId')
            ? [...new Set((params.get('classId') || '').split(',').filter(Boolean))]
            : null,
    }
}

export const classAnalyticsUrl = (classId, search) => {
    const current = new URLSearchParams(search)
    const params = new URLSearchParams({ id: classId })
    for (const key of ['days', 'from', 'to']) {
        if (current.has(key)) params.set(key, current.get(key))
    }
    return `/analytics/class?${params}`
}
